export const ErrorMessages = {
  'errors.default'             : 'Something went wrong. Please try again!',
  'errors.unavailable'         : 'Service unavailable!',
  'errors.unauthorized'        : 'You are not allowed access here!',
  'errors.login.invalid'       : 'Username / password incorrect!',
  'errors.message.absent'      : 'Please enter your message.',
  'errors.feedname.absent'	   : 'Please enter alert name',
  'errors.area.absent' 		     : 'Please select an area of interest',
  'errors.propertytype.absent' : 'Please select a property type',
  'errors.note.save'           : 'Note could not be saved. Please try again!',
  'errors.note.delete'         : 'Note could not be deleted. Please try again!',
  'errors.alert.save'          : 'Alert could not be saved. Please try again!',
  'errors.cdo.save'            : 'CDO could not be saved. Please try again!',
  'errors.notloggedin'         : 'You do not seem to be logged in!',
  'errors.domain.blacklisted'  : 'JLL has an enterprise agreement with Property Capsule and we ask that you please contact your JLL administrator to sign up'
}



// WEBPACK FOOTER //
// ./src/app/constants/ErrorMessages.ts